module.exports = __webpack_public_path__ + "p9_img1.jpg?1eff7a12be7d160c1065bf7c4868190c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p9/p9_img1.jpg
// module id = 135
// module chunks = 0